export default __webpack_public_path__ + "static/1119-112046855dded945531a6fbbc8b9ca46.gif";